<template>
  <div class="app-logo">
    <logo-svg viewBox="0 0 196 40"></logo-svg>
  </div>
</template>

<script setup>
import LogoSvg from '@/assets/svg/logo.svg?component'
</script>
